// extracted by mini-css-extract-plugin
export default {"hand":"Hand_hand__89vsO"};